import VendorHead from '~/components/common/layouts/head/VendorHead';

import { useSearchResultsSeoContext } from '../../contexts/SearchResultsSeoContext';

/**
 * Injects the SEO/meta tags into the search results page
 */
export const SearchResultsHead = () => {
  const { title, description, canonicalUrl, imageUrl, noIndex } = useSearchResultsSeoContext();
  return (
    <VendorHead
      title={title}
      description={description}
      canonicalUrl={canonicalUrl}
      imageUrl={imageUrl}
      noindex={noIndex}
    />
  );
};
